import type React from 'react';

export const JoevLogo: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 342.6 93.6"
    xmlSpace="preserve"
    {...props}
  >
    <g>
      <g>
        <path
          className="st0"
          d="M287.3,47.6l-36.8-34.3v64.6h-11.4l-63.8-65.4H91.9v65.4h-9.8V12.4H50.2v34.3L16.7,85.2h148.8V20.6h8.2v64.6 h116.1l33.5-33.5V12.4L287.3,47.6z M243.8,12.4h-31.5v31.5h31.5V12.4z"
        />
      </g>
      <g>
        <path
          className="st1"
          d="M287.3,47.6l-36.8-34.3v64.6h-11.4l-63.8-65.4H91.9v65.4h-9.8V12.4H50.2v34.3L16.7,85.2h148.8V20.6h8.2v64.6 h116.1l33.5-33.5V12.4L287.3,47.6z M243.8,12.4h-31.5v31.5h31.5V12.4z"
        />
      </g>
    </g>
  </svg>
);

export default JoevLogo;
